/**
 * @generated SignedSource<<1436cf83e9b93c8436c8af4db491afd5>>
 * @relayHash 108869bd4c06115f8f9f0ff8c9a127c5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f68c4c7707f381f1c3f0f1a3ee53e89ee13820c668a65595515e57da3f34c65f

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type CustomerExperiencesListRefetchQuery$variables = {
  cloudId: string;
  currentCustomerExperienceAri: string;
  fetchCurrentCustomerExperience?: boolean | null;
};
export type CustomerExperiencesListRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CustomerExperiencesList_currentCustomerExperience">;
};
export type CustomerExperiencesListRefetchQuery = {
  response: CustomerExperiencesListRefetchQuery$data;
  variables: CustomerExperiencesListRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "currentCustomerExperienceAri"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "fetchCurrentCustomerExperience"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "CustomerExperiencesListRefetchQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          {
            "kind": "Variable",
            "name": "currentCustomerExperienceAri",
            "variableName": "currentCustomerExperienceAri"
          },
          {
            "kind": "Variable",
            "name": "fetchCurrentCustomerExperience",
            "variableName": "fetchCurrentCustomerExperience"
          }
        ],
        "kind": "FragmentSpread",
        "name": "CustomerExperiencesList_currentCustomerExperience"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CustomerExperiencesListRefetchQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/)
        ],
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "condition": "fetchCurrentCustomerExperience",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "currentCustomerExperience",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "helpCenterAri",
                    "variableName": "currentCustomerExperienceAri"
                  }
                ],
                "kind": "LinkedField",
                "name": "helpCenterById",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "type"
                      },
                      {
                        "concreteType": "HelpCenterName",
                        "kind": "LinkedField",
                        "name": "name",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "default"
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hoistedProjectKey"
                      }
                    ],
                    "type": "HelpCenter"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v2/*: any*/)
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "f68c4c7707f381f1c3f0f1a3ee53e89ee13820c668a65595515e57da3f34c65f",
    "metadata": {},
    "name": "CustomerExperiencesListRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a6ab31f88287b0373d7a9c77af235b6f";

export default node;
